import useFilterStore from '../../components/streetview/filterStore';
import { filterCount } from '../../utils/filters';
import useAllFilterStore from './allFilterStore';

export default function useFilterCount() {
  const { selectedFilters } = useFilterStore();
  const { filterTypeLookup } = useAllFilterStore();
  return filterCount(selectedFilters, filterTypeLookup);
}
